import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=4aea7ba9&scoped=true&"
import script from "./ImageWidget.vue?vue&type=script&lang=js&"
export * from "./ImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea7ba9",
  null
  
)

export default component.exports